module.exports = __webpack_public_path__ + "img/fuwuhao.0d1bea91.png";